import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AppShell } from './components/AppShell.tsx';
import { DatasetProvider, useDataset } from './data/DatasetContext.tsx';
import { DroughtsPage } from './pages/DroughtsPage.tsx';
import { LoginPage } from './pages/LoginPage.tsx';
import { OverviewPage } from './pages/OverviewPage.tsx';
import { MemoryPage } from './pages/MemoryPage.tsx';
import { PaperSimulationPage } from './pages/PaperSimulationPage.tsx';
import { ProfitCalculatorPage } from './pages/ProfitCalculatorPage.tsx';
import { AutoAnalyzerPage } from './pages/AutoAnalyzerPage.tsx';
import { MultiplierExplorerPage } from './pages/MultiplierExplorerPage.tsx';

export function AppRoutes() {
  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<OverviewPage />} />
        <Route path="/overview" element={<Navigate to="/" replace />} />
        <Route path="/droughts" element={<DroughtsPage />} />
        <Route path="/profit" element={<ProfitCalculatorPage />} />
        <Route path="/memory" element={<MemoryPage />} />
        <Route path="/auto-analyzer" element={<AutoAnalyzerPage />} />
        <Route path="/multipliers" element={<MultiplierExplorerPage />} />
        <Route path="/paper" element={<PaperSimulationPage />} />
        <Route path="/explore" element={<Navigate to="/droughts" replace />} />
        <Route path="/simulate" element={<Navigate to="/paper" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  );
}

function AuthenticatedApp() {
  const { session, loading } = useDataset();
  if (loading && session.authRequired && !session.authenticated) {
    return <LoginPage />;
  }
  if (session.authRequired && !session.authenticated) {
    return <LoginPage />;
  }
  return <AppRoutes />;
}

export function App() {
  return (
    <BrowserRouter>
      <DatasetProvider>
        <AuthenticatedApp />
      </DatasetProvider>
    </BrowserRouter>
  );
}
